import { FORM_ASK_FOR_VALIDATE } from './form-askfor-types';
import Papa from 'papaparse';
import { Iitem, IinValidData, IData } from '../../../models/askfor.interface';

/**
 * Function that handles the  drag and drop file upload
 */
export const askForValidationUpload = (validation: string, existingData?: any) => {
  if (checkForUpload()) {
    FORM_ASK_FOR_VALIDATE.askForDropArea.classList.add('has-advanced-upload');

    FORM_ASK_FOR_VALIDATE.askForDropArea.addEventListener('dragover', event => {
      event.preventDefault();
      event.stopPropagation();
    });

    FORM_ASK_FOR_VALIDATE.askForDropArea.addEventListener('dragenter', event => {
      event.preventDefault();
      event.stopPropagation();
      FORM_ASK_FOR_VALIDATE.askForDropArea.classList.add('is-dragover');
    });

    FORM_ASK_FOR_VALIDATE.askForDropArea.addEventListener('drop', event => {
      event.preventDefault();
      event.stopPropagation();
      FORM_ASK_FOR_VALIDATE.askForDropArea.classList.remove('is-dragover');

      const file: any = event.dataTransfer?.files;

      if(file[0].type != 'text/csv') {
        FORM_ASK_FOR_VALIDATE.askForDropArea.classList.add('is-error');
        FORM_ASK_FOR_VALIDATE.askForFileError.innerText = 'Error! Only CSV files are allowed.';
      } else {
        FORM_ASK_FOR_VALIDATE.askForDropArea.classList.remove('is-error');
        FORM_ASK_FOR_VALIDATE.askForDropArea.classList.add('is-success');
      }      

      const reader = new FileReader();
      let header: [] = [];

      reader.readAsText(file[0]);

      reader.addEventListener('load', event => {
        let csvData = event.target?.result;
        // @ts-ignore
        let parsedData = Papa.parse(csvData, {
          delimiter: ',',
          header: true,
          skipEmptyLines: true,
          dynamicTyping: true
        });

        // @ts-ignore
        const { data, errors, meta } = parsedData;

        // TODO: validate header to allow just the Pins or Pins and Description

        Object.values(meta.fields).forEach((item: any) => {
          if (item != 'Pin' && item != 'Description') {
            // @ts-ignore
            header.push({ error: `Header name ${item} is invalid. Correct header format is Pin and Description.`});
          }
        });

        if (header.length > 0) {
          Object.values(header).forEach((entry: any) => {
              FORM_ASK_FOR_VALIDATE.askForValidationValues.value += `${entry.error}\n`;
          });
          FORM_ASK_FOR_VALIDATE.askForValidationValues.classList.add('invalid-pins');
          FORM_ASK_FOR_VALIDATE.validateSubmit.setAttribute('disabled', 'disabled');
        } else {
          const { valid, invalid } = checkData(data);

          if( Object.keys(invalid).length != 0 ) {          
            FORM_ASK_FOR_VALIDATE.askForValidationValues.classList.add('invalid-pins');
            FORM_ASK_FOR_VALIDATE.askForDropArea.classList.remove('is-success');
            FORM_ASK_FOR_VALIDATE.validateSubmit.setAttribute('disabled', 'disabled');
            Object.values(invalid).forEach((entry: any) => {
              FORM_ASK_FOR_VALIDATE.askForValidationValues.value += `${entry.item.Pin}  ${entry.item.Description}  Reason: ${entry.message}\n`;
            });
            return;
          } 

          FORM_ASK_FOR_VALIDATE.askForValidationValues.classList.remove('invalid-pins');
          FORM_ASK_FOR_VALIDATE.validateSubmit.removeAttribute('disabled');
          FORM_ASK_FOR_VALIDATE.askForValidationValues.value = '';
          if(Object.keys(existingData).length >= 1 && validation != '0') {         
            Object.values(existingData).forEach((item: any) => {
              FORM_ASK_FOR_VALIDATE.askForValidationValues.value += `${item.Pin}  ${item.Description}\n`;
            });
          }
          Object.values(valid).forEach((entry: any) => {
            FORM_ASK_FOR_VALIDATE.askForValidationValues.value += `${entry.Pin}  ${entry.Description}\n`; 
          });
        }

        // #TODO: create a helper function that will take both valid and invalid data and display it in the textarea
        //        if valid then submit the data
        //        if invalid then display the data in the textarea with the error message, disable the submit button and display the textarea in a red shade

         // 
      });
    });
  }
}

const checkForUpload = () => {
  let div = document.createElement('div');

  return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
}

const checkData = (data: object): IData => {
  console.log('data', data);
  let validData: Array<Iitem> = [];
  let invalidData: Array<IinValidData> = [];

  const schema = {
    Pin: (value: number) => {            
      if ((value.toString().length < 5 || value.toString().length > 12) || !Number.isInteger(value)) {
        return false;
      } else {
        return true;
      }
    },
    Description: (value: any) => value.length <= 128 && String(value)
  }

  // @ts-ignore
  schema.Pin.required = true
  // @ts-ignore
  schema.Description.required = true;

  const validate = (object: any, schema: any) => Object
                    .entries(schema)
                    .map(([key, validate]: [any, any], index: number) => [
                      key,
                      !validate.required || (key in object),
                      validate(object[key])
                    ])
                    .filter(([_, ...tests]) => !tests.every(Boolean))
                    .map(([key, invalid]) => new Error(`${key} is ${invalid ? 'invalid' : 'required'}.`));

  

 

  Object.values(data).forEach((item: any, index: number) => {
    const error = validate(item, schema);

    if (error.length > 0) {
      for (const { message } of error) {
        invalidData.push({item, message});
      }
    } else {
      validData.push(item);
    }        
  });

  return {
    valid: validData,
    invalid: invalidData
  }
}